import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';

export default new RouteHandler({
    init() {
        const $button = $('.form-control');
        const $form = $('.login-form__form');
        const $wrapper = $(':loginForm');
        const $onlineBanking = $(':onlineBanking');
        const $passwordInput = $(':passwordInput');
        const $showPassword = $(':showPassword');

        const setAttributes = (buttonExpanded, formHidden, tabindex) => {
            $button.attr({
                'aria-expanded': buttonExpanded,
            });

            $form.attr({
                'aria-hidden': formHidden,
            });

            $('.form__input', $form).each((el) => {
                $(el).attr('tabindex', tabindex);
            });

            $('.form__link', $wrapper).each((el) => {
                $(el).attr('tabindex', tabindex);
            });

            $(':loginButton', $wrapper).attr('tabindex', tabindex);
        };

        const toggleForm = () => {
            $wrapper.toggleClass('-expanded');

            if ($wrapper.hasClass('-expanded')) {
                setAttributes('true', 'false', '0');
            } else {
                setAttributes('false', 'true', '-1');
            }
        };

        const hideForm = () => {
            $wrapper.removeClass('-expanded');
            setAttributes('false', 'true', '-1');
        };

        const resetReveal = () => {
            if ($showPassword.length) {
                $showPassword[0].checked = false;
            }
        };

        const passwordReveal = (e) => {
            if ($passwordInput.length) {
                if (e.target.checked) {
                    $passwordInput[0].type = 'text';
                } else {
                    $passwordInput[0].type = 'password';
                }
            }
        };

        $events.on({
            ':showPassword': {
                change: passwordReveal,
            },
        });

        // The form shouldn't have the expand/collapse behavior on the sign-in page.
        if (! $onlineBanking.length) {
            $events.on({
                '.form-control': {
                    click: toggleForm,
                },
                document: {
                    mousewheel: hideForm,
                    scroll: hideForm,
                },
            });
        }

        resetReveal();
        toggleForm();
    },
});
